import { TableCell, TableRow, Button } from '@/components/ui';
import { format } from 'date-fns';
import { Eye, Trash2 } from 'lucide-react';
import { TypeBadge } from './TypeBadge';
import { AmountDisplay } from './AmountDisplay';
import { getTitleEnumValue } from '@/functions';
import type { IDataTableProps } from '@/interfaces';

export const DataTableDesktopRow = ({ transaction, onViewDetails, onDelete, canDelete }: IDataTableProps) => {
	return (
		<TableRow
			key={transaction._id}
			className="h-12 cursor-pointer hover:bg-muted/50 transition-colors"
			onClick={() => onViewDetails(transaction)}
		>
			<TableCell className="font-mono text-sm">
				{format(new Date(transaction.occurredAt || transaction.createdAt || new Date()), 'dd/MM/yyyy')}
			</TableCell>
			<TableCell>
				<TypeBadge type={transaction.type} />
			</TableCell>
			<TableCell className="font-medium text-sm">{getTitleEnumValue('TransactionCategoryEnum', transaction.category) ?? transaction.category}</TableCell>
			<TableCell className="text-left">
				<AmountDisplay amount={transaction.amountEur} type={transaction.type} />
			</TableCell>
			<TableCell className="text-sm text-muted-foreground max-w-[200px]">
				<div className="truncate" title={transaction.description || transaction.data?.description}>
					{transaction.description || transaction.data?.description}
				</div>
			</TableCell>
			<TableCell className="text-right">
				<div className="flex items-center justify-end space-x-1">
					<Button
						variant="ghost"
						size="icon"
						className="h-8 w-8"
						onClick={e => {
							e.stopPropagation();
							onViewDetails(transaction);
						}}
						title="Voir les détails"
					>
						<Eye size={14} />
					</Button>
					{canDelete && onDelete && (
						<Button
							variant="ghost"
							size="icon"
							className="h-8 w-8 text-destructive hover:text-destructive hover:bg-destructive/10"
							onClick={e => {
								e.stopPropagation();
								onDelete(transaction);
							}}
							title="Supprimer"
						>
							<Trash2 size={14} />
						</Button>
					)}
				</div>
			</TableCell>
		</TableRow>
	);
};
